// cross-fetch.js
export default fetch
